<script>
  import FinancierPlan from '@/components/Financier/Plan';

  export default {
    components: {
      FinancierPlan,
    },

    computed: {
      plans () {
        return [
          {
            title: 'Starter',
            badge: 'Limite Baixo',
            perks: [
              'Navegação na plataforma',
            ],
            infos: [
              {
                verified: true,
                label: 'CPF / CNPJ',
              },
              {
                verified: true,
                label: 'Data de nascimento / Fundação',
              },
            ],
          },
          {
            title: 'Intermediário',
            badge: 'Limite Médio',
            parent: 'Starter',
            perks: [
              'Saques e depósitos com mais facilidade',
              'Compra / venda e trader com mais facilidade',
              'Aumento no fundo de limites',
            ],
            deposit: {
              btc: true,
              real: 'R$ 350.000,00',
            },
            withdraw: {
              btc: 'BTC 35.00000000',
              real: 'R$ 350.000,00',
            },
            infos: [
              {
                verified: true,
                label: 'Documento RG / CNH',
              },
              {
                verified: false,
                label: 'Comprovante de endereço',
              },
              {
                verified: true,
                label: 'Número de telefone',
              },
            ],
          },
          {
            title: 'Pro',
            badge: 'Limite Alto',
            parent: 'Intermediário',
            perks: [
              'Limites de fundo personalizado',
            ],
            deposit: {
              btc: true,
              real: 'R$ 100MM ++',
            },
            withdraw: {
              btc: 'R$ 100MM ++',
              real: 'R$ 100MM ++',
            },
            infos: [
              {
                verified: false,
                label: 'Imposto de renda e extrato bancário de até 90 dias',
              },
              {
                verified: false,
                label: 'Verificação de prevenção à lavagem de dinheiro ',
              },
            ],
          },
        ];
      },
    },
  };
</script>

<template>
  <main>
    <h1 class="sidebar__title">Limites Operacionais</h1>

    <article class="row">
      <FinancierPlan
        v-bind="plan"
        class="col--4"
        :key="plan.title"
        v-for="plan in plans"
        />
    </article>
  </main>
</template>
